import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { BrandProvider } from "@/context/BrandContext";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Driver from "@/pages/Driver";
import Track from "@/pages/Track";
import Vehicles from "@/pages/Vehicles";
import Drivers from "@/pages/Drivers";
import Users from "@/pages/Users";
import TripHistory from "@/pages/TripHistory";
import Playback from "@/pages/Playback";
import Geofences from "@/pages/Geofences";
import Branding from "@/pages/Branding";
import AdminTools from "@/pages/AdminTools";

const Protected = ({ children, roles }) => {
  const { user, checking } = useAuth();
  if (checking)
    return (
      <div className="flex h-screen items-center justify-center text-xs tracking-[0.3em] text-[#52525B]">
        INITIALISING DOOT…
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
};

const ADMIN = ["admin"];
const OPS = ["admin", "dispatcher"];

function App() {
  return (
    <AuthProvider>
      <BrandProvider>
      <BrowserRouter>
        <Toaster theme="dark" position="top-right" />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/driver" element={<Driver />} />
          <Route path="/track/:token" element={<Track />} />
          <Route
            path="/"
            element={
              <Protected>
                <Dashboard />
              </Protected>
            }
          />
          <Route
            path="/admin"
            element={
              <Protected roles={OPS}>
                <AdminTools />
              </Protected>
            }
          />
          <Route
            path="/trips"
            element={
              <Protected roles={OPS}>
                <TripHistory />
              </Protected>
            }
          />
          <Route
            path="/playback"
            element={
              <Protected roles={OPS}>
                <Playback />
              </Protected>
            }
          />
          <Route
            path="/vehicles"
            element={
              <Protected roles={ADMIN}>
                <Vehicles />
              </Protected>
            }
          />
          <Route
            path="/drivers"
            element={
              <Protected roles={ADMIN}>
                <Drivers />
              </Protected>
            }
          />
          <Route
            path="/users"
            element={
              <Protected roles={ADMIN}>
                <Users />
              </Protected>
            }
          />
          <Route
            path="/geofences"
            element={
              <Protected roles={OPS}>
                <Geofences />
              </Protected>
            }
          />
          <Route
            path="/branding"
            element={
              <Protected roles={ADMIN}>
                <Branding />
              </Protected>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      </BrandProvider>
    </AuthProvider>
  );
}

export default App;
